import { render, staticRenderFns } from "./total-count.vue?vue&type=template&id=2448a9f9&scoped=true&"
import script from "./total-count.vue?vue&type=script&lang=js&"
export * from "./total-count.vue?vue&type=script&lang=js&"
import style0 from "./total-count.vue?vue&type=style&index=0&id=2448a9f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448a9f9",
  null
  
)

export default component.exports